import { OMS_ORDER_SUBSCRIPTIONS_HMAC_PATH } from '../../constants/paths';
import { apiB2B } from '../axios-client';
import { getUserId } from '../../utils/user';

const userId = getUserId() ?? '';

export const getOrderSubscriptionHMAC = () => {
  return apiB2B.get(OMS_ORDER_SUBSCRIPTIONS_HMAC_PATH(userId));
};
